// extracted by mini-css-extract-plugin
module.exports = {"section":"Section-module--section--Alnet","documentation":"Section-module--documentation--2bQH4","code":"Section-module--code--3e33x"};